import { Route, Routes } from 'react-router-dom';
import SolumKnowledgeBase from './SolumKnowledgeBase';
import LogFileReader from './LogFileReader';
import SolumToolSuiteLayout from './SolumToolSuiteLayout';
import GatewayTester from './GatewayTester';
import LicenseManagement from './LicenseManagement';
import DragAndDropUploader from './DragAndDropUploader';
import WalmartRoutersDashboard from './WalmartRoutersDashboard';
import MainHomepage from './MainHomepage';
import GatewaySshManager from './GatewaySshManager';
import LowesGatewayFwRevert from './LowesGatewayFwRevert';
import VideoSync from './VideoSync';

function SolumToolSuite() {
  return (
    <SolumToolSuiteLayout>
      <Routes>
        <Route path="/" element={
          <div style={{ padding: '3rem', textAlign: 'center', color: '#fff' }}>
            <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>Solum Tool Suite</h1>
            <p style={{ fontSize: '1.2rem', opacity: 0.8 }}>
              Select a tool from the menu to get started
            </p>
          </div>
        } />
        <Route path="/main-homepage" element={<MainHomepage />} />
        <Route path="/solum-knowledge-base" element={<SolumKnowledgeBase />} />
        <Route path="/log-file-reader" element={<LogFileReader />} />
        <Route path="/gateway-tester" element={<GatewayTester />} />
        <Route path="/license-management" element={<LicenseManagement />} />
        <Route path="/drag-and-drop-uploader" element={<DragAndDropUploader />} />
        <Route path="/router-fleet-status" element={<WalmartRoutersDashboard />} />
        <Route path="/gateway-ssh-manager" element={<GatewaySshManager />} />
        <Route path="/lowes-gateway-fw-revert" element={<LowesGatewayFwRevert />} />
        <Route path="/video-sync" element={<VideoSync />} />
      </Routes>
    </SolumToolSuiteLayout>
  );
}

export default SolumToolSuite;
